/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_InvoiceInputs */

const en_doc_type_invoice = /** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice / Receipt`)
};

const id_doc_type_invoice = /** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktur / Tanda Terima`)
};

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const es_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const fr_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const de_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const ja_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const zh_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const ar_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const it_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const ru_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const pt_doc_type_invoice = en_doc_type_invoice;

/** @type {(inputs: Doc_Type_InvoiceInputs) => LocalizedString} */
const ko_doc_type_invoice = en_doc_type_invoice;

/**
* | output |
* | --- |
* | "Invoice / Receipt" |
*
* @param {Doc_Type_InvoiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_invoice = /** @type {((inputs?: Doc_Type_InvoiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_InvoiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_invoice(inputs)
	if (locale === "es") return es_doc_type_invoice(inputs)
	if (locale === "fr") return fr_doc_type_invoice(inputs)
	if (locale === "de") return de_doc_type_invoice(inputs)
	if (locale === "ja") return ja_doc_type_invoice(inputs)
	if (locale === "zh") return zh_doc_type_invoice(inputs)
	if (locale === "ar") return ar_doc_type_invoice(inputs)
	if (locale === "id") return id_doc_type_invoice(inputs)
	if (locale === "it") return it_doc_type_invoice(inputs)
	if (locale === "ru") return ru_doc_type_invoice(inputs)
	if (locale === "pt") return pt_doc_type_invoice(inputs)
	return ko_doc_type_invoice(inputs)
});